import { render, staticRenderFns } from "./CircleDetail.vue?vue&type=template&id=45bf90f6&scoped=true"
import script from "./CircleDetail.vue?vue&type=script&lang=js"
export * from "./CircleDetail.vue?vue&type=script&lang=js"
import style0 from "./CircleDetail.vue?vue&type=style&index=0&id=45bf90f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf90f6",
  null
  
)

export default component.exports